import React, { useEffect, useState } from 'react'
import YoutubeList from '../../components/YoutubeList/YoutubeList';
import { FirebaseHelper } from '../../firebase-helper';
import './YoutubeListsSection.scss';
import $ from 'jquery';
import ExternalButton from '../../components/ExternalButton/ExternalButton';

class YoutubeListSectionClass {
    static youtubeListInstance = true;
}


function YoutubeListsSection() {

    const firebaseHelperYoutubeLists = new FirebaseHelper("youtube-lists");
    const youtubeListRef = firebaseHelperYoutubeLists.usersCollectionRef;

    const [youtubeLists, setYoutubeLists] = useState();
    var youtueListsLength = 0;

    useEffect(() => {
        const getYoutubeList = async () => {
            var youtubeList = await FirebaseHelper.getAllDocs(youtubeListRef);;
            youtueListsLength = youtubeList.length;
            setYoutubeLists(youtubeList);
            console.log("Youtube List Fetched");
        }
        getYoutubeList();
        if (YoutubeListSectionClass.youtubeListInstance) {
            setInterval(slideCards, 3000);
            YoutubeListSectionClass.youtubeListInstance = false;
            console.log("Youtue List Sliding Started");
        }

    }, [])

    var direction = false;
    const slideCards = () => {
        if (youtubeLists == 0) {
            return;
        }


        const slide = $('#slider-container')
        var sliding = 420;
        if (window.innerWidth <= 500) {
            sliding = 250;
        }
        var width = youtueListsLength * sliding;
        try{
            var scrollWidth = slide[0].offsetWidth;
        }catch(exception){
            return;
        }
        

        if (slide.scrollLeft() + scrollWidth > width) {
            direction = true;
        } else if (slide.scrollLeft() == 0) {
            direction = false
        }

        if (direction) {
            slide.animate({ scrollLeft: "-=" + sliding }, 1000);
        } else {
            slide.animate({ scrollLeft: "+=" + sliding }, 1000);
        }


    }


    return (
        <div className='youtube-list-section'>
            <ExternalButton url="https://www.youtube.com/channel/UCacyf_eXIR0w_95dvzoOmdg/playlists?view=1&sort=dd&shelf_id=0">
                <h2>My Youtube List</h2>
            </ExternalButton>

            <div id='slider-container' className='youtube-lists'>

                {
                    youtubeLists && youtubeLists.map((yt) => {
                        return (
                            <YoutubeList key={yt.id} youtubeList={yt} />
                        )
                    })

                }
            </div>
        </div>

    )
}

export default YoutubeListsSection